import React from "react";

export const ExpertIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="35"
        viewBox="0 0 30 35"
        fill="none">
        <g filter="url(#filter0_d_1043_5267)">
          <rect
            x="3"
            y="3"
            width="24"
            height="24.4999"
            rx="12"
            fill="#1784F7"
          />
          <rect
            x="1.5"
            y="1.5"
            width="27"
            height="27.4999"
            rx="13.5"
            stroke="url(#paint0_linear_1043_5267)"
            stroke-width="3"
          />
          <path
            d="M24.289 19.3749V11.1249C24.289 10.7739 24.1966 10.429 24.021 10.125C23.8455 9.82095 23.593 9.56848 23.289 9.39295L16.1445 5.26795C15.8405 5.09241 15.4956 5 15.1445 5C14.7934 5 14.4485 5.09241 14.1445 5.26795L7 9.39295C6.69597 9.56848 6.4435 9.82095 6.26796 10.125C6.09243 10.429 6.00001 10.7739 6 11.1249V19.3749C6.00001 19.726 6.09243 20.0709 6.26796 20.3749C6.4435 20.6789 6.69597 20.9314 7 21.1069L14.1445 25.2319C14.4485 25.4075 14.7934 25.4999 15.1445 25.4999C15.4956 25.4999 15.8405 25.4075 16.1445 25.2319L23.289 21.1069C23.593 20.9314 23.8455 20.6789 24.021 20.3749C24.1966 20.0709 24.289 19.726 24.289 19.3749Z"
            stroke="white"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.5155 11.41L23.6875 10.1299M14.9995 25.4913V20.3708M9.56952 12.0501L6.31152 10.1299M10.2495 13.4639H12.2495V19.5889H10.2495V13.4639ZM13.9995 12.1879H15.9995V18.3128H13.9995V12.1879ZM17.7495 10.9118H19.7495V17.0368H17.7495V10.9118Z"
            stroke="white"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1043_5267"
            x="0"
            y="0"
            width="30"
            height="34.5"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="4"
              operator="erode"
              in="SourceAlpha"
              result="effect1_dropShadow_1043_5267"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.232156 0 0 0 0 0.243941 0 0 0 0 0.298077 0 0 0 0.33 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1043_5267"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1043_5267"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_1043_5267"
            x1="15"
            y1="3"
            x2="15"
            y2="27.4999"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="white" />
            <stop offset="1" stop-color="#EEEEEE" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
